let mercadorRadius = 85445659.44705395
let mercadorOffset = 268435456

function longitudeToPixelSpaceX( longitude ) {
	return Math.round( mercadorOffset + mercadorRadius * longitude * Math.PI / 180.0 )
}

function latitudeToPixelSpaceY( latitude ) {
	return Math.round(mercadorOffset - mercadorRadius * Math.log( ( 1 + Math.sin( latitude * Math.PI / 180.0 ) ) / ( 1 - Math.sin( latitude * Math.PI / 180.0 ) ) ) / 2.0 )
}

function pixelSpaceXToLongitude( pixelX ) {
	return ( ( Math.round( pixelX ) - mercadorOffset ) / mercadorRadius ) * 180.0 / Math.PI
}

function pixelSpaceYToLatitude( pixelY ) {
	return ( Math.PI / 2.0 - 2.0 * Math.atan( Math.exp( ( Math.round( pixelY ) - mercadorOffset ) / mercadorRadius ) ) ) * 180.0 / Math.PI
}

/**
 * @see https://medium.com/@xavierletohic/how-to-migrate-from-google-maps-api-javascript-to-apple-mapkit-js-dc862f1f0a89
 *
 * @param {object} map
 * @param {object} centerCoordinates
 * @param {number} zoomLevel
 */
export default function getDeltaFromZoomLevel( map, centerCoordinates, zoomLevel ) {
	// Convert center coordiate to pixel space:
	let centerPixelX = longitudeToPixelSpaceX( centerCoordinates.longitude )
	let centerPixelY = latitudeToPixelSpaceY( centerCoordinates.latitude )

	// Determine the scale value from the zoom level:
	let zoomExponent = 20 - zoomLevel
	let zoomScale = Math.pow( 2, zoomExponent )

	// Scale the map’s size in pixel space:
	let mapSizeInPixels = map.visibleMapRect.size
	let scaledMapWidth = mapSizeInPixels.width * zoomScale
	let scaledMapHeight = mapSizeInPixels.height * zoomScale

	// Figure out the position of the top-left pixel:
	let topLeftPixelX = centerPixelX - ( scaledMapWidth / 2 )
	let topLeftPixelY = centerPixelY - ( scaledMapHeight / 2 )

	// Find delta between left and right longitudes:
	let minLng = pixelSpaceXToLongitude( topLeftPixelX )
	let maxLng = pixelSpaceXToLongitude( topLeftPixelX + scaledMapWidth )
	let longitudeDelta = maxLng - minLng

	// Find delta between top and bottom latitudes:
	let minLat = pixelSpaceYToLatitude( topLeftPixelY )
	let maxLat = pixelSpaceYToLatitude( topLeftPixelY + scaledMapHeight )
	let latitudeDelta = -1 * ( maxLat - minLat )

	// Create and return the lat/lng span:
	return {
		latitudeDelta,
		longitudeDelta
	}
}
